module.exports = __webpack_public_path__ + "img/bigScreen.99c817b0.png";